const jsonSchema = [
  {
    name: 'description',
    label: 'Description',
    type: 'text',
    required: true,
    showInList: true
  },
  {
    type: 'group',
    fields: [
      {
        name: 'maxClasses',
        label: 'Max Classes',
        type: 'number',
        showInList: true,
        required: true
      },

      {
        name: 'price',
        label: 'Price',
        type: 'currency',
        showInList: true,
        required: true
      }
    ]
  },
  {
    name:'billingCyrcle',
    label: 'Billing cyrcle',
    type: 'multiselect',
    required:true,
    options: [{label:'day', value:'day'}, {label:'week', value:'week'}, {label:'month', value:'month'}, {label:'year', value:'year'}, {label:'one-off-payment', value:'one_time'}],
    showInList: true
  },
  {
    name:'moreInformation',
    label: 'More information',
    type: 'textarea',
    required:false,
    showInList: false
  },
  {
    name:'hidden',
    label: 'Hidden',
    type: 'checkbox',
    required:false,
    showInList: true
  }


  // Add more fields as needed
];
export default jsonSchema;
